import { Modal } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { HxngMonetisation, isRXMT2 } from '../../../../pages/utils';

interface Props {
    type: HxngMonetisation;
    isVisible?: boolean;
    closeMe: () => void;
    monetizeAmount?: number;
    initiatingRxMonetization: () => Promise<void>;
    isLoading?: boolean;
    disabled?: boolean;
    isFetchingCartDetails?: boolean;
}

export class MonetizeRxInfoModal extends PureComponent<Props> {
    onClick = async (): Promise<void> => {
        const { initiatingRxMonetization, closeMe } = this.props;
        try {
            await initiatingRxMonetization();
        } finally {
            closeMe();
        }
    };

    render(): ReactNode {
        const {
            isVisible,
            closeMe,
            monetizeAmount,
            isLoading,
            disabled,
            isFetchingCartDetails,
            type,
        } = this.props;
        const { onClick } = this;

        return (
            <Modal
                onCancel={closeMe}
                width={600}
                closable={false}
                visible={isVisible}
                destroyOnClose
                footer={null}
                bodyStyle={{
                    padding: '0px',
                    borderRadius: '12px !important',
                    height: '500px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                className="overflow-hidden rounded-12"
                style={{ height: '500px' }}
            >
                <div className="flex-1 grid grid-cols-2">
                    <div className="bg-darwin-neutral-50 p-24">
                        <p className="text-28 font-700 leading-9">
                            Earn{' '}
                            <span className="text-darwin-accent-bright-blue-800">
                                {isFetchingCartDetails
                                    ? ' Fetching'
                                    : monetizeAmount
                                    ? `upto ₹ ${monetizeAmount}`
                                    : ''}
                            </span>{' '}
                            on this prescription
                        </p>
                        <p className="mt-8 mb-24">
                            by providing <span>free medicine home delivery</span> to your patient.
                        </p>
                        <div className="space-y-16">
                            <div className="flex items-start space-x-8">
                                <p className="pt-3">
                                    <svg
                                        className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                                        viewBox="0 0 12 13"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M6 12.5C2.67188 12.5 0 9.82812 0 6.5C0 3.19531 2.67188 0.5 6 0.5C9.30469 0.5 12 3.19531 12 6.5C12 9.82812 9.30469 12.5 6 12.5ZM8.64844 5.39844H8.625C8.85938 5.1875 8.85938 4.83594 8.625 4.60156C8.41406 4.39062 8.0625 4.39062 7.85156 4.60156L5.25 7.22656L4.14844 6.125C3.91406 5.89062 3.5625 5.89062 3.35156 6.125C3.11719 6.33594 3.11719 6.6875 3.35156 6.89844L4.85156 8.39844C5.0625 8.63281 5.41406 8.63281 5.64844 8.39844L8.64844 5.39844Z" />
                                    </svg>
                                </p>
                                <p>
                                    <span className="text-darwin-accent-bright-blue-800">
                                        100%{' '}
                                    </span>
                                    transparency
                                </p>
                            </div>

                            <div className="flex items-start space-x-8">
                                <p className="pt-3">
                                    <svg
                                        className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                                        viewBox="0 0 12 13"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M6 12.5C2.67188 12.5 0 9.82812 0 6.5C0 3.19531 2.67188 0.5 6 0.5C9.30469 0.5 12 3.19531 12 6.5C12 9.82812 9.30469 12.5 6 12.5ZM8.64844 5.39844H8.625C8.85938 5.1875 8.85938 4.83594 8.625 4.60156C8.41406 4.39062 8.0625 4.39062 7.85156 4.60156L5.25 7.22656L4.14844 6.125C3.91406 5.89062 3.5625 5.89062 3.35156 6.125C3.11719 6.33594 3.11719 6.6875 3.35156 6.89844L4.85156 8.39844C5.0625 8.63281 5.41406 8.63281 5.64844 8.39844L8.64844 5.39844Z" />
                                    </svg>
                                </p>
                                <p>
                                    No additional{' '}
                                    <span className="text-darwin-accent-bright-blue-800">
                                        operational cost.
                                    </span>
                                </p>
                            </div>

                            <div className="flex items-start space-x-8">
                                <p className="pt-3">
                                    <svg
                                        className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                                        viewBox="0 0 12 13"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M6 12.5C2.67188 12.5 0 9.82812 0 6.5C0 3.19531 2.67188 0.5 6 0.5C9.30469 0.5 12 3.19531 12 6.5C12 9.82812 9.30469 12.5 6 12.5ZM8.64844 5.39844H8.625C8.85938 5.1875 8.85938 4.83594 8.625 4.60156C8.41406 4.39062 8.0625 4.39062 7.85156 4.60156L5.25 7.22656L4.14844 6.125C3.91406 5.89062 3.5625 5.89062 3.35156 6.125C3.11719 6.33594 3.11719 6.6875 3.35156 6.89844L4.85156 8.39844C5.0625 8.63281 5.41406 8.63281 5.64844 8.39844L8.64844 5.39844Z" />
                                    </svg>
                                </p>
                                <p>
                                    <span className="text-darwin-accent-bright-blue-800">
                                        End-to-end{' '}
                                    </span>
                                    customer support{' '}
                                    <span className="text-darwin-accent-bright-blue-800">
                                        powered by Eka.
                                    </span>
                                </p>
                            </div>

                            <div className="flex items-start space-x-8">
                                <p className="pt-3">
                                    <svg
                                        className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                                        viewBox="0 0 12 13"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M6 12.5C2.67188 12.5 0 9.82812 0 6.5C0 3.19531 2.67188 0.5 6 0.5C9.30469 0.5 12 3.19531 12 6.5C12 9.82812 9.30469 12.5 6 12.5ZM8.64844 5.39844H8.625C8.85938 5.1875 8.85938 4.83594 8.625 4.60156C8.41406 4.39062 8.0625 4.39062 7.85156 4.60156L5.25 7.22656L4.14844 6.125C3.91406 5.89062 3.5625 5.89062 3.35156 6.125C3.11719 6.33594 3.11719 6.6875 3.35156 6.89844L4.85156 8.39844C5.0625 8.63281 5.41406 8.63281 5.64844 8.39844L8.64844 5.39844Z" />
                                    </svg>
                                </p>
                                <p>
                                    No{' '}
                                    <span className="text-darwin-accent-bright-blue-800">
                                        spam calls or messages{' '}
                                    </span>
                                    to the patient.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="p-24 relative"
                        style={{
                            background:
                                'linear-gradient(132.34deg, #232477 21.75%, #04052E 64.68%)',
                        }}
                    >
                        <div
                            className="flex items-center justify-center w-26 h-26 bg-white absolute top-16 right-16 cursor-pointer rounded-full"
                            onClick={closeMe}
                        >
                            <svg
                                className="w-13 h-13 fill-darwin-neutral-900"
                                viewBox="0 0 12 12"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z" />
                            </svg>
                        </div>

                        <div className="text-white flex flex-col h-full">
                            <p
                                className="text-32 font-700 pr-24 mb-10"
                                style={{ lineHeight: '42px' }}
                            >
                                100% Genuine Medicines &amp; Lab Reports
                            </p>
                            <p className="font-500 text-18">At your door steps</p>
                            <div className="flex-1 flex items-center">
                                <img
                                    src="/images/hxng-concent.png"
                                    className="relative right-32 h-204"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="px-24 py-12 flex items-center justify-center">
                    <div>
                        <button
                            className={`flex items-center justify-center space-x-12 px-16 py-12 bg-darwin-accent-bright-blue-800 rounded-8 text-white font-700 ${
                                disabled ? 'opacity-70' : ''
                            }`}
                            disabled={disabled}
                            onClick={type === isRXMT2 ? closeMe : onClick}
                        >
                            {isLoading && (
                                <svg
                                    className="w-16 h-16 fill-white animate-spin"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                </svg>
                            )}
                            <p>Start Now</p>
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}
